export const Footer = () => {
    return (
        <footer>
            <div className='footer__contact_information'>
                <div className="">Developer contact information <a href='tel:+48500468674'>+48500468674</a></div>
                <div className="">email <a href='mailto:allisoncatcher797@gmail.com'>allisoncatcher797@gmail.com</a>
            </div>
            </div>
            <div className="footer__copyright">TickViral is official trademark belonging to <span>Criptas LLC</span>
            </div>
            <div className="footer__copyright">TickViral Android app is developed by <span>Criptas LLC</span>
            </div>
        </footer>
    )
}
